export const MUS_BG = "mus-bg";

export const SPRITESHEET_MUSIC_GAME: string[] = ["musicgame-1"];
export const SPRITESHEET_SPOTLIGHTS: string[] = ["spotlights-1"];
export const MUS_BTN_VAR = "mus-btn-var";
export const MUS_LIGHT_ = "mus-light-";
export const _OVERLAY = "-overlay";
export const MUS_BTN_MUTE = "mus-btn-mute";
export const MUS_RAMP = "mus-ramp";
